var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { observer } from 'mobx-react';
import Messages from '../conversation/messages/messages';
import SendMessage from '../conversation/sendmessage/send-message';
import { ConversationSetup } from '../conversation/conversationSetup';
import * as singleton from '../store/singleton';
import './conversation.scss';
var Conversation = (function (_super) {
    __extends(Conversation, _super);
    function Conversation(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.initialize();
        return _this;
    }
    Object.defineProperty(Conversation.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (React.createElement("div", { className: "conversation-container" },
                React.createElement(Messages, { store: this.store, masterAccountId: this.props.masterAccountId, userId: this.props.userId, employeeSourceId: this.props.employeeSourceId, entityId: this.props.entityId, entityType: this.props.entityType, unreadMessageCount: this.props.unreadMessageCount, onRead: this.props.onMessagesRead }),
                this.renderSendMessage()));
        }
    });
    Object.defineProperty(Conversation.prototype, "renderSendMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.props.disabled) {
                return null;
            }
            return (React.createElement(SendMessage, { store: this.store, masterAccountId: this.props.masterAccountId, userId: this.props.userId, entityType: this.props.entityType, entityId: this.props.entityId, onMessageSent: this.props.onMessageSent }));
        }
    });
    Object.defineProperty(Conversation.prototype, "initialize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.props, hidePeopleInChat = _a.hidePeopleInChat, uploadFileSizeLimit = _a.uploadFileSizeLimit, fileExtensions = _a.fileExtensions, conversationUrl = _a.conversationUrl, employeeUrl = _a.employeeUrl, accessToken = _a.accessToken;
            this.store = ConversationSetup.createStore(hidePeopleInChat, uploadFileSizeLimit, fileExtensions);
            singleton.init(employeeUrl, conversationUrl, accessToken);
        }
    });
    return Conversation;
}(React.Component));
export { Conversation };
export default observer(Conversation);
